var _circle, _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsDataDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "white",
    stroke: "#ECECEC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10.3333,
    width: 8,
    height: 6.66667,
    rx: 1,
    stroke: "#EB662B",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.111C9 11.3823 9 11.018 9.18085 10.7597C9.24776 10.6641 9.33087 10.581 9.42642 10.5141C9.6847 10.3333 10.0491 10.3333 10.7778 10.3333H15.2222C15.9509 10.3333 16.3153 10.3333 16.5736 10.5141C16.6691 10.581 16.7522 10.6641 16.8192 10.7597C17 11.018 17 11.3823 17 12.111H9Z",
    fill: "#EB662B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7773 9L10.7773 10.3333",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2227 9L15.2227 10.3333",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7773,
    y: 13,
    width: 1.77778,
    height: 0.888889,
    rx: 0.444444,
    fill: "#EB662B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7773,
    y: 14.7778,
    width: 1.77778,
    height: 0.888889,
    rx: 0.444444,
    fill: "#EB662B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4434,
    y: 13,
    width: 1.77778,
    height: 0.888889,
    rx: 0.444444,
    fill: "#EB662B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4434,
    y: 14.7778,
    width: 1.77778,
    height: 0.888889,
    rx: 0.444444,
    fill: "#EB662B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsDataDate);
export default __webpack_public_path__ + "static/media/ps-data-date.d76fc7597b7c6b0ad9af5ed4c60b6391.svg";
export { ForwardRef as ReactComponent };